<form [formGroup]="formulario">
  <div class="row">
    <div class="col-12 col-md-1">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>ID</mat-label>
        <input formControlName="id" matInput readonly>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-4">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Nome Fantasia</mat-label>
        <input formControlName="nomeFantasia" matInput minlength="3" maxlength="250" required>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-4">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Razão Social</mat-label>
        <input formControlName="razaoSocial" matInput minlength="3" maxlength="250" required>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-3">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Telefone</mat-label>
        <input formControlName="telephone" matInput mask="(00) 0 0000-0000 || (00) 0000-0000" required>
      </mat-form-field>
    </div>
  </div>
  <app-endereco-cadastro [formulario]="formulario" [showObservation]="true"></app-endereco-cadastro>
</form>
